





































import { Component, Vue } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountIcon,
  },
})
export default class ProjectOperators extends Vue {
  private desserts = [
    {
      name: 'Frozen Yogurt',
      calories: 159,
    },
    {
      name: 'Ice cream sandwich',
      calories: 237,
    },
    {
      name: 'Eclair',
      calories: 262,
    },
    {
      name: 'Cupcake',
      calories: 305,
    },
    {
      name: 'Gingerbread',
      calories: 356,
    },
    {
      name: 'Jelly bean',
      calories: 375,
    },
    {
      name: 'Lollipop',
      calories: 392,
    },
    {
      name: 'Crunky',
      calories: 392,
    },
    {
      name: 'Creme de peche',
      calories: 392,
    },
  ];
}
